import { recieveProjects } from "./reducer";
import { APIClient } from "../../../helpers/api_helper";
const api = new APIClient();

export const loadProjects= () => async (dispatch, getState) => {

    try {
        const data = await api.get('/api/projects/get_options/')

        if (data) {
            dispatch(recieveProjects(data));
        }
    } catch (error) {
        console.error('Unable to load projects!', error)
    }
};
